import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterOrigineDemandeByNamePipe } from 'src/app/shared/pipes/filter-origineDemande-by-name/filter-origineDemande-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { OrigineDemandeModalDetailComponent } from './modal/origineDemande-modal-detail/origineDemande-modal-detail.component';
import { OrigineDemandeModalAjoutComponent } from './modal/origineDemande-modal-ajout/origineDemande-modal-ajout.component';
import { ListOrigineDemandeComponent } from './list-origineDemande/list-origineDemande.component';

@NgModule({
	declarations: [
		ListOrigineDemandeComponent,
		OrigineDemandeModalDetailComponent,
		OrigineDemandeModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterOrigineDemandeByNamePipe]
})

export class OrigineDemandeModule {}
